import styled from "styled-components";

export const Container = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  img {
    height: 80px;
    /* height: 50px; */
  }
  p {
    font-size: 30px;
    margin: 0;
    text-decoration: none;
  }
`;
